import React from "react";

const TableStatusLegend = ({ statusOptions, tables, getStatusColor }) => {
  const safeTables = Array.isArray(tables) ? tables : [];
  const safeOptions = Array.isArray(statusOptions) ? statusOptions : [];

  return (
    <div className="ns-table-legend">
      <style>{legendStyles}</style>

      <div className="ns-table-legend-title">Legend</div>

      <div className="ns-table-legend-items">
        {safeOptions.map((option) => {
          const count = safeTables.filter((table) => table.status === option.value).length;
          const color = getStatusColor?.(option.value) || "#64748b";

          return (
            <div key={option.value} className="ns-table-legend-item">
              <span
                className="ns-table-legend-swatch"
                style={{
                  "--legend-color": color,
                }}
              />
              <span className="ns-table-legend-label">{option.label}</span>
              <strong>{count}</strong>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const legendStyles = `
  .ns-table-legend {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .ns-table-legend-title {
    color: #0f172a;
    font-size: 0.82rem;
    font-weight: 950;
    padding-right: 4px;
  }

  .ns-table-legend-items {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .ns-table-legend-item {
    min-height: 32px;
    border-radius: 999px;
    background: #ffffff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    color: #334155;
    padding: 5px 9px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.04);
    font-size: 0.75rem;
    font-weight: 850;
  }

  .ns-table-legend-swatch {
    width: 12px;
    height: 12px;
    border-radius: 5px;
    border: 2px solid var(--legend-color);
    background: color-mix(in srgb, var(--legend-color) 12%, #ffffff);
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--legend-color) 10%, transparent);
  }

  .ns-table-legend-label {
    white-space: nowrap;
  }

  .ns-table-legend-item strong {
    min-width: 22px;
    height: 22px;
    border-radius: 999px;
    background: #f8fafc;
    color: #0f172a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.72rem;
    font-weight: 950;
    padding: 0 7px;
  }

  @supports not (background: color-mix(in srgb, red 10%, #fff)) {
    .ns-table-legend-swatch {
      background: #ffffff;
    }
  }
`;

export default TableStatusLegend;
